import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const RangedBarracks = {
  id: "8",
  name: "Ranged Barracks",
  width: 3,
  height: 5,
  type: BuildingType.BARRACKS,
  era: "stoneAge",
  icon: "Ranged",
  minLevel: 1,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Barracks/Ranged_Barracks',
  flags: 0,
  counts: {
    stoneAge: 1,
    bronzeAge: 1,
    minoanEra: 1,
    classicGreece: 1,
    earlyRome: 1,
    romanEmpire: 1,
    byzantineEra: 1,
    ageOfTheFranks: 1,
    feudalAge: 1,
    iberianEra: 1,
    kingdomOfSicily: 1,
    highMiddleAges: 1,
    earlyGothicEra: 1,
    lateGothicEra: 1,
  },
  effects: Effects.create([
    new Happiness({
      stoneAge: [90, 180, 360],
      bronzeAge: [140, 270, 540],
      minoanEra: [180, 360, 720],
      classicGreece: [240, 480, 960],
      earlyRome: [300, 600, 1200],
      romanEmpire: [360, 720, 1440],
      byzantineEra: [420, 840, 1680],
      ageOfTheFranks: [510, 1020, 2040],
      feudalAge: [600, 1200, 2400],
      iberianEra: [720, 1440, 2880],
      kingdomOfSicily: [870, 1740, 3480],
      highMiddleAges: [1050, 2100, 4200],
      earlyGothicEra: [1260, 2520, 5040],
      lateGothicEra: [1500, 3000, 6000],
    })
  ]),
};

export default RangedBarracks;
